import DatabaseModel from './DatabaseModelOffline.js';

var Formato = Object.create(DatabaseModel);

Formato.model = 'formatos';

export default Formato;